var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-item-content"},[_c('img',{staticClass:"img-item",style:({
      borderTopLeftRadius: _vm.topRadius ? _vm.topRadius : '',
      borderTopRightRadius: _vm.topRadius ? _vm.topRadius : '',
      borderBottomLeftRadius: _vm.bottomRadius ? _vm.bottomRadius : '',
      borderBottomRightRadius: _vm.bottomRadius ? _vm.bottomRadius : '',
      background: _vm.background ? _vm.background : '',
      objectFit: _vm.realMode,
    }),attrs:{"src":_vm.imageUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }